<div class="maintenance-banner" *ngIf="messages.length">
  <div class="maintenance-banner-message">
    <mat-icon>campaign</mat-icon>
    <span><b>{{ messages[0].title }}</b>: <span [innerHTML]="messages[0].message"></span></span>

    <div class="maintenance-banner-actions">
      <button
        *ngIf="messages.length > 1"
        type="button"
        class="maintenance-banner-toggle"
        [attr.aria-expanded]="expanded"
        (click)="toggleExpanded()"
      >
        {{ (expanded ? 'maintenance-banner.show-less' : 'maintenance-banner.show-more') | translate: { count: messages.length - 1 } }}
      </button>

      <button
        type="button"
        class="maintenance-banner-dismiss"
        [attr.aria-label]="'maintenance-banner.dismiss' | translate"
        (click)="dismiss(messages[0])"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <ng-container *ngIf="expanded">
    <div class="maintenance-banner-message" *ngFor="let message of messages.slice(1)">
      <mat-icon>campaign</mat-icon>
      <span><b>{{ message.title }}</b>: <span [innerHTML]="message.message"></span></span>

      <div class="maintenance-banner-actions">
        <button
          type="button"
          class="maintenance-banner-dismiss"
          [attr.aria-label]="'maintenance-banner.dismiss' | translate"
          (click)="dismiss(message)"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </ng-container>
</div>
